import { render, staticRenderFns } from "./UploadAcceptedE-InvoicesButton.vue?vue&type=template&id=1dcd8f9a"
import script from "./UploadAcceptedE-InvoicesButton.vue?vue&type=script&lang=js"
export * from "./UploadAcceptedE-InvoicesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports